import { classNames } from "primereact/utils";
import styles from "./EmployeeChipStrip.module.scss";
import { IEmployeeWithAvailabilityModel } from "../models/employeeCalendarModels";

interface IEmployeeChipStripProps {
  employees: IEmployeeWithAvailabilityModel[];
  activeEmployeeId?: number;
  onSelect: (id: number) => void;
}

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
};

export const EmployeeChipStrip = ({
  employees,
  activeEmployeeId,
  onSelect,
}: IEmployeeChipStripProps) => {
  return (
    <div className={styles.strip} role="radiogroup" aria-label="Служители">
      {employees.map((employee) => {
        const isActive = employee.id === activeEmployeeId;
        return (
          <button
            key={employee.id}
            type="button"
            role="radio"
            aria-checked={isActive}
            className={classNames(styles.chip, {
              [styles.chip_active]: isActive,
            })}
            onClick={() => onSelect(employee.id)}
          >
            <span className={styles.avatar}>{getInitials(employee.name)}</span>
            <span className={styles.name}>{employee.name}</span>
          </button>
        );
      })}
    </div>
  );
};
